import { aboutContent } from '@wineryxplorer/shared';
import type { AboutParagraph } from '@wineryxplorer/shared';
import { PageContainer } from '../components/PageContainer';
import { Typography } from '../components/ui/Typography';
import { BuildStamp } from '../components/BuildStamp';

const renderParagraph = (paragraph: AboutParagraph, key: number) => {
  if (typeof paragraph === 'string') {
    return <p key={key}>{paragraph}</p>;
  }

  return (
    <p key={key}>
      {paragraph.map((run, i) =>
        run.href ? (
          <a
            key={i}
            href={run.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-secondary-700 underline underline-offset-2 hover:text-secondary-800"
          >
            {run.text}
          </a>
        ) : (
          <span key={i}>{run.text}</span>
        )
      )}
    </p>
  );
};

export const About = () => {
  return (
    <div className="px-0 md:px-4 pt-2 pb-4">
      <PageContainer>
        {/* Reading-width column — opt-in narrower than navbar for long-form
            prose. Per apps/web/CLAUDE.md this is the established pattern for
            reading-focused pages. */}
        <div className="max-w-3xl mx-auto px-3 md:px-4 py-6 md:py-10">
          <Typography variant="heading1" as="h1" className="text-gray-900 mb-6">
            {aboutContent.title}
          </Typography>

          {aboutContent.sections.map((section, sectionIdx) => (
            <div key={sectionIdx}>
              {section.heading ? (
                <Typography
                  variant="heading3"
                  as="h2"
                  className="text-gray-900 mb-6 mt-6"
                >
                  {section.heading}
                </Typography>
              ) : null}
              <div className="space-y-6 font-sans text-base md:text-lg leading-relaxed text-gray-800">
                {section.paragraphs.map((p, i) => renderParagraph(p, i))}
              </div>
            </div>
          ))}

          <BuildStamp />
        </div>
      </PageContainer>
    </div>
  );
};
